import React from "react"
import { Route, Redirect } from "react-router-dom"
import { LoadingComponent } from "@pga/pga-component-library"
import ErrorCard from "../components/ErrorCard"
import { prop, isNil, propOr, isEmpty } from "ramda"
import {
  LL_ROUTE_ACCESS_QUERY,
  toLegacyStatusCode,
  useLifelongLearningQuery,
} from "../components/Education/lifelongLearning"

const PROGRAM_KEY_BY_CODE = { SPP: "spp", CPP3: "cpp", MPP3: "mpp" }

// The server decides whether a member can view a program's progress; a rule
// that names specific statuses must also match the program's current status.
export const memberCanAccessRoute = ({ me, rules = [] }) =>
  rules.some(rule => {
    const program =
      me?.lifelongLearning?.[PROGRAM_KEY_BY_CODE[rule.programCode]]
    if (!program?.eligibility?.canViewProgress) return false
    const specificStatusCodes = propOr([], "status", rule)
    return isEmpty(specificStatusCodes)
      ? true
      : specificStatusCodes.includes(toLegacyStatusCode(program.status))
  })

export const RouteOrRedirect =
  ({ me, Component, rules }) =>
  props =>
    memberCanAccessRoute({ me, rules }) ? (
      <Component {...props} />
    ) : (
      <Redirect to="/education/programs" />
    )

export const HandleQuery = ({
  data,
  loading,
  error,
  Component,
  rules,
  routeProps,
}) => {
  if (loading) return <LoadingComponent />
  if (error) return <ErrorCard />

  const me = prop("me", data)

  return !isNil(me) ? (
    <Route {...routeProps} render={RouteOrRedirect({ me, rules, Component })} />
  ) : null
}

const CheckEducationStatus = ({
  component: Component,
  rules,
  ...routeProps
}) => {
  const { data, loading, error } = useLifelongLearningQuery(
    LL_ROUTE_ACCESS_QUERY,
  )
  return HandleQuery({ data, loading, error, Component, rules, routeProps })
}

export default CheckEducationStatus
